import { Fragment, FunctionComponent } from 'react'
import { Alert, Text, Textarea, getTheme } from '@conexasaude/conexa-hero'
import Modal from '@/components/Modal'
import { CareModals } from '../../types'
import { Icon } from '@conexasaude/iconography/icons'
import useStyles from './CareFakedoorModal.styles'
import { CareFakedoorModalProps } from './CareFakedoorModal.types'
import { useCareFakedoorModal } from './CareFakedoorModal.hook'
import { CARE_FAKEDOOR_MODAL_TEXTS } from './CareFakedoorModal.constants'

const CareFakedoorModal: FunctionComponent<CareFakedoorModalProps> = props => {
  const theme = getTheme()
  const styles = useStyles()

  const { step, close, STEPS, textAreaValue, setTextAreaValue } =
    useCareFakedoorModal(props)

  const getStepContent = () => {
    switch (step) {
      case 0:
        return (
          <Fragment>
            <div css={styles.modalBGWrapper}>
              <Icon
                size={48}
                name="hand-heart"
                color={theme.colors.brand.primary[300]}
              />
              <Text variant="subheading" fontWeight={700}>
                {CARE_FAKEDOOR_MODAL_TEXTS.unavailableFeature.description}
              </Text>
            </div>
            <Text css={styles.modalSoonText}>
              {CARE_FAKEDOOR_MODAL_TEXTS.unavailableFeature.question}
            </Text>
          </Fragment>
        )
      case 1:
        return (
          <div css={styles.modalContent}>
            <Alert
              variant="success"
              title={CARE_FAKEDOOR_MODAL_TEXTS.sendFeedback.alert.title}
            ></Alert>
            <Text variant="subheading" fontWeight={700}>
              {CARE_FAKEDOOR_MODAL_TEXTS.sendFeedback.description}
            </Text>
            <Text variant="paragraphSmall">
              {CARE_FAKEDOOR_MODAL_TEXTS.sendFeedback.description2}
            </Text>
            <Textarea
              label=""
              fullWidth
              maxLength={300}
              value={textAreaValue}
              onChange={e => setTextAreaValue(e.target.value)}
              placeholder={CARE_FAKEDOOR_MODAL_TEXTS.sendFeedback.placeholder}
            />
          </div>
        )
      case 2:
        return (
          <div css={styles.modalBGWrapper}>
            <Icon
              size={48}
              name="hand-heart"
              color={theme.colors.brand.primary[300]}
            />
            <Text variant="subheading" fontWeight={700}>
              {CARE_FAKEDOOR_MODAL_TEXTS.sendedFeedback.description}
            </Text>
          </div>
        )
      default:
        return null
    }
  }

  return (
    <Modal
      size={480}
      trapFocus={false}
      negativeAction={close}
      id={CareModals.Fakedoor}
      title={STEPS[step].title}
      onDismiss={() => close()}
      primaryAction={STEPS[step].primaryAction}
      primaryActionLabel={STEPS[step].primaryActionLabel}
      negativeActionLabel={STEPS[step].negativeActionLabel}
      disabledPrimaryAction={step === 1 && !textAreaValue.trim()}
    >
      {getStepContent()}
    </Modal>
  )
}

export { CareFakedoorModal }
